import {
  hideChatwootSupport,
  initializeChatwootSupport,
  openChatwootSupport,
  popoutChatwootSupport,
  showChatwootSupport,
} from './chatwoot'
import { createSupportCoordinator } from './supportCoordinator'

export {
  SUPPORT_PROVIDERS,
  type SupportContext,
  type SupportProvider,
} from './supportCoordinator'

const supportCoordinator = createSupportCoordinator({
  initializeChatwoot: initializeChatwootSupport,
  hideChatwoot: hideChatwootSupport,
  showChatwoot: showChatwootSupport,
  openChatwoot: openChatwootSupport,
  popoutChatwoot: popoutChatwootSupport,
})

export const {
  initializeSupport,
  openSupport,
  openSupportInNewTab,
  hideSupport,
  showSupport,
} = supportCoordinator
